export default __webpack_public_path__ + "static/media/avatar-3.9318cd73.png";